import { OnInit } from '@angular/core';
import { DetailService } from '../services/detail.service';
import { MdePopoverTrigger } from '@material-extended/mde';
import { WorkspaceService } from '../services/workspace.service';
var HelpComponent = /** @class */ (function () {
    function HelpComponent(detailService, workspaceService) {
        this.detailService = detailService;
        this.workspaceService = workspaceService;
        this.loadingMessage = "Loading the element help display text... Please wait for a moment";
        this.position = "top";
        // this.workspaceService.documentClickChanged$.subscribe(result => {
        //   this.offClickHandler(result);
        // })
    }
    Object.defineProperty(HelpComponent.prototype, "placement", {
        set: function (event) {
            this.position = event;
        },
        enumerable: true,
        configurable: true
    });
    HelpComponent.prototype.ngOnInit = function () {
        this.helpDisplay = this.loadingMessage;
        this.getHelpById();
    };
    HelpComponent.prototype.getHelpById = function () {
        var _this = this;
        if (this.helpDisplay == "Loading the element help display text... Please wait for a moment") {
            document.querySelectorAll("body").item(0).style.position = "relative";
            this.detailService.getHelp(this.helpId).subscribe(function (result) {
                _this.helpDisplay = result;
            });
        }
    };
    return HelpComponent;
}());
export { HelpComponent };
